import React from 'react';
import { FiPhone, FiMail, FiCalendar, FiHash } from 'react-icons/fi';
import styles from '../Lead.module.css';
import { nomeCurtoFluxo } from '../fluxos';

const STATUS_CLASS = {
  'Aguardando':  'statusNovo',
  'Aprovado':    'statusConvertido',
  'Sem Retorno': 'statusPerdido',
};

function formatarData(iso) {
  const [a, m, d] = iso.split('-');
  return `${d}/${m}/${a}`;
}

function LeadCard({ lead, onEditar, onVerDetalhes }) {
  const statusCls = styles[STATUS_CLASS[lead.status]] ?? '';

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div>
          <p className={styles.cardNome}>{lead.nome}</p>
          <p className={styles.cardEmpresa}>{lead.empresa}</p>
          <span className={`${styles.seloFluxo} ${lead.tipoFluxo ? '' : styles.seloLegado}`}>{nomeCurtoFluxo(lead.tipoFluxo)}</span>
        </div>
        <span className={`${styles.status} ${statusCls}`}>{lead.status}</span>
      </div>

      {(lead.cnpj || lead.cpf) && (
        <div className={styles.cardDocumento}>
          <FiHash className={styles.cardContatoIcon} />
          <span>{lead.cnpj || lead.cpf}</span>
        </div>
      )}

      <div className={styles.cardContatos}>
        {lead.telefone && (
          <span className={styles.cardContato}>
            <FiPhone className={styles.cardContatoIcon} /> {lead.telefone}
          </span>
        )}
        {lead.email && (
          <span className={styles.cardContato}>
            <FiMail className={styles.cardContatoIcon} /> {lead.email}
          </span>
        )}
      </div>

      {lead.servicosInteresse.length > 0 && (
        <div className={styles.servicos}>
          {lead.servicosInteresse.map((s) => (
            <span key={s} className={styles.servicoBadge}>{s}</span>
          ))}
        </div>
      )}

      <div className={styles.cardFooter}>
        <span className={styles.cardData}>
          <FiCalendar /> {formatarData(lead.dataCadastro)}
        </span>
        <div className={styles.cardAcoes}>
          <button
            className={`${styles.btnAcao} ${styles.btnEditar}`}
            onClick={() => onEditar(lead)}
          >
            Editar
          </button>
          <button
            className={`${styles.btnAcao} ${styles.btnDetalhe}`}
            onClick={() => onVerDetalhes(lead)}
          >
            Ver detalhes
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeadCard;
